/**
 * app/init 스케쥴러에서 전달하는 UA 입니다. 그 외에 서버사이드에서 호출 시 UA 가 없는 경우에도 사용합니다.
 */
export const DEFAULT_SERVER_SIDE_UA =
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 DEFAULT';

/**
 * 서버사이드에서 UA 를 만들 때 붙여줄 postfix 입니다.
 * 레퍼러 체크 시 이 값 여부로 서버사이드 여부를 체크합니다
 */
export const UA_POSTFIX_FROM_SERVER_SIDE = 'KakaoPageWeb/';
// 서버사이드 렌더링에서 호출하는 경우
export const UA_POSTFIX_FROM_SSR = `${UA_POSTFIX_FROM_SERVER_SIDE}ssr`;
// graphql resolver 내의 RestDataSource 에서 호출하는 경우
export const UA_POSTFIX_FROM_GRAPHQL = `${UA_POSTFIX_FROM_SERVER_SIDE}graphql`;
// proxy 에서 호출하는 경우 /api/api/xx 로 호출하는 경우임
export const UA_POSTFIX_FROM_PROXY = `${UA_POSTFIX_FROM_SERVER_SIDE}proxy`;
// scheduler 에서 호출하는 경우. 현재는 /app/init 만 있음
export const UA_POSTFIX_FROM_SCHEDULER = `${UA_POSTFIX_FROM_SERVER_SIDE}scheduler`;
